import { createReducer } from '@reduxjs/toolkit';
import {
  receiveThreadDetail,
  clearThreadDetail,
  upvoteThreadDetail,
  downThreadDetail,
  neutralThreadDetail,
  addComment,
  upvoteComment,
  downvoteComment,
  neutralvoteComment,
} from './action';

const threadDetailReducer = createReducer(null, (builder) => {
  builder
    .addCase(receiveThreadDetail.type, (state, action) => {
      return action.payload.threadDetail;
    })
    .addCase(clearThreadDetail.type, (state, action) => {
      return null;
    })
    .addCase(upvoteThreadDetail, (state, action) => {
      const { userId } = action.payload;
      state.upVotesBy.push(userId);
      state.downVotesBy = state.downVotesBy.filter((id) => id !== userId);
    })
    .addCase(downThreadDetail.type, (state, action) => {
      const { userId } = action.payload;
      state.upVotesBy = state.upVotesBy.filter((id) => id !== userId);
      state.downVotesBy.push(userId);
    })
    .addCase(neutralThreadDetail.type, (state, action) => {
      const { userId } = action.payload;
      state.upVotesBy = state.upVotesBy.filter((id) => id !== userId);
      state.downVotesBy = state.downVotesBy.filter((id) => id !== userId);
    })
    .addCase(addComment.type, (state, action) => {
      state.comments.push(action.payload.comment);
    })
    .addCase(upvoteComment.type, (state, action) => {
      const { userId, commentId } = action.payload;
      const comment = state.comments.find(({ id }) => id === commentId);
      comment.upVotesBy.push(userId);
      comment.downVotesBy = comment.downVotesBy.filter((id) => id !== userId);
    })
    .addCase(downvoteComment.type, (state, action) => {
      const { userId, commentId } = action.payload;
      const comment = state.comments.find(({ id }) => id === commentId);
      comment.upVotesBy = comment.upVotesBy.filter((id) => id !== userId);
      comment.downVotesBy.push(userId);
    })
    .addCase(neutralvoteComment.type, (state, action) => {
      const { userId, commentId } = action.payload;
      const comment = state.comments.find(({ id }) => id === commentId);
      comment.upVotesBy = comment.upVotesBy.filter((id) => id !== userId);
      comment.downVotesBy = comment.downVotesBy.filter((id) => id !== userId);
    });
});
export default threadDetailReducer;
